import "./CustomerDataInput.css";
import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import { detect } from "detect-browser";
import { Tooltip } from "antd";

export default class CustomerDataInput extends Component {
  constructor(props) {
    super(props);

    this.executePricingRequest = this.executePricingRequest.bind(this);
    this.handleChange = this.handleChange.bind(this);

    const browser = detect();
    this.state = {
      customerEmail: "",
      customerId: "",
      customerSalutation: "",
      customerName: "",
      customerForename: "",
      customerCountry: "",
      customerCompany: "",
      customerStreet: "",
      customerZip: "",
      customerCity: "",
      customerMessage: "",
      browser: browser
    };
  }

  componentDidMount() {
    this.setState({
      customerEmail: this.props.shopParameters.customerEmail
        ? this.props.shopParameters.customerEmail
        : "",
      customerId: this.props.shopParameters.customerId
        ? this.props.shopParameters.customerId
        : "",
      customerSalutation: this.props.shopParameters.customerSalutation
        ? this.props.shopParameters.customerSalutation
        : "",
      customerName: this.props.shopParameters.customerName
        ? this.props.shopParameters.customerName
        : "",
      customerForename: this.props.shopParameters.customerForename
        ? this.props.shopParameters.customerForename
        : "",
      customerCountry: this.props.shopParameters.customerCountry
        ? this.props.shopParameters.customerCountry
        : ""
    });
  }

  handleChange(field, event) {
    if (
      this.state.browser === undefined ||
      !(
        this.state.browser.version !== undefined &&
        this.state.browser.version.length > 0 &&
        this.state.browser.version[0] === "9" &&
        this.state.browser.name === "ie"
      )
    ) {
      this.setState({ [field]: event.target.value });
    } else {
      this.setState({ [field]: event.currentTarget.value });
    }
  }

  executePricingRequest(e) {
    e.preventDefault();

    var inputData = {};
    inputData.customerEmail = this.state.customerEmail;
    inputData.customerId = this.state.customerId;
    inputData.customerSalutation = this.state.customerSalutation;
    inputData.customerName = this.state.customerName;
    inputData.customerForename = this.state.customerForename;
    inputData.customerCountry = this.state.customerCountry;
    inputData.customerCompany = this.state.customerCompany;
    inputData.customerStreet = this.state.customerStreet;
    inputData.customerZip = this.state.customerZip;
    inputData.customerCity = this.state.customerCity;
    inputData.customerMessage = this.state.customerMessage;

    this.props.executePricingRequest(inputData);
  }

  render() {
    return (
      <form className="needs-validation" onSubmit={this.executePricingRequest}>
        <div className="form-row">
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_Email" />}
              placement="topLeft"
            >
              <label htmlFor="inputEmail">
                <Translate id="ContactForm_Email" /> *
              </label>
            </Tooltip>
            <input
              type="email"
              className="form-control"
              id="inputEmail"
              value={this.state.customerEmail}
              onChange={event => this.handleChange("customerEmail", event)}
              required
            />
          </div>
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_CustomerNo" />}
              placement="topLeft"
            >
              <label htmlFor="inputCustomerNumber">
                <Translate id="ContactForm_CustomerNo" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputCustomerNumber"
              value={this.state.customerId}
              onChange={event => this.handleChange("customerId", event)}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-2">
            <Tooltip
              title={<Translate id="ContactForm_Salutation" />}
              placement="topLeft"
            >
              <label
                htmlFor="inputSalutation"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                <Translate id="ContactForm_Salutation" />
              </label>
            </Tooltip>
            <Translate>
              {({ translate }) => (
                <select
                  id="inputSalutation"
                  className="form-control"
                  value={this.state.customerSalutation}
                  onChange={event =>
                    this.handleChange("customerSalutation", event)
                  }
                >
                  <option value="">
                    {translate("SearchForm_PleaseSelect")}
                  </option>
                  <option value={translate("ContactForm_Mr")}>
                    {translate("ContactForm_Mr")}
                  </option>
                  <option value={translate("ContactForm_Mrs")}>
                    {translate("ContactForm_Mrs")}
                  </option>
                </select>
              )}
            </Translate>
          </div>
          <div className="form-group col-md-4">
            <Tooltip
              title={<Translate id="ContactForm_Firstname" />}
              placement="topLeft"
            >
              <label htmlFor="inputVorname">
                <Translate id="ContactForm_Firstname" />
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputVorname"
              value={this.state.customerForename}
              onChange={event => this.handleChange("customerForename", event)}
            />
          </div>
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_Lastname" />}
              placement="topLeft"
            >
              <label htmlFor="inputNachname">
                <Translate id="ContactForm_Lastname" />
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputNachname"
              value={this.state.customerName}
              onChange={event => this.handleChange("customerName", event)}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_Company" />}
              placement="topLeft"
            >
              <label htmlFor="inputFirma">
                <Translate id="ContactForm_Company" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputFirma"
              required
              value={this.state.customerCompany}
              onChange={event => this.handleChange("customerCompany", event)}
            />
          </div>
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_Street" />}
              placement="topLeft"
            >
              <label htmlFor="inputStreet">
                <Translate id="ContactForm_Street" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputStreet"
              required
              value={this.state.customerStreet}
              onChange={event => this.handleChange("customerStreet", event)}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-2">
            <Tooltip
              title={<Translate id="ContactForm_Zip" />}
              placement="topLeft"
            >
              <label
                htmlFor="inputZip"
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                <Translate id="ContactForm_Zip" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputZip"
              required
              value={this.state.customerZip}
              onChange={event => this.handleChange("customerZip", event)}
            />
          </div>
          <div className="form-group col-md-4">
            <Tooltip
              title={<Translate id="ContactForm_City" />}
              placement="topLeft"
            >
              <label htmlFor="inputCity">
                <Translate id="ContactForm_City" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputCity"
              required
              value={this.state.customerCity}
              onChange={event => this.handleChange("customerCity", event)}
            />
          </div>
          <div className="form-group col-md-6">
            <Tooltip
              title={<Translate id="ContactForm_Country" />}
              placement="topLeft"
            >
              <label htmlFor="inputCountry">
                <Translate id="ContactForm_Country" /> *
              </label>
            </Tooltip>
            <input
              type="text"
              className="form-control"
              id="inputCountry"
              value={this.state.customerCountry}
              onChange={event => this.handleChange("customerCountry", event)}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-12">
            <Tooltip
              title={<Translate id="ContactForm_Message" />}
              placement="topLeft"
            >
              <label htmlFor="inputMessage">
                <Translate id="ContactForm_Message" />
              </label>
            </Tooltip>
            <textarea
              type="text"
              className="form-control"
              id="inputMessage"
              value={this.state.customerMessage}
              onChange={event => this.handleChange("customerMessage", event)}
            />
          </div>
        </div>
        <div className="form-group">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="gridCheck"
              required
            />
            <label className="form-check-label" htmlFor="gridCheck">
              * <Translate id="ContactForm_PrivacyStatement" />
            </label>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-12" style={{ textAlign: "center" }}>
            <button className="btn btn-sm button-brand" type="submit">
              <Translate id="ContactForm_Submit" />
            </button>
          </div>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomerDataInput.js